import { render, staticRenderFns } from "./RepoList.vue?vue&type=template&id=72c6f1da&scoped=true&"
import script from "./RepoList.vue?vue&type=script&lang=js&"
export * from "./RepoList.vue?vue&type=script&lang=js&"
import style0 from "./RepoList.vue?vue&type=style&index=0&id=72c6f1da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c6f1da",
  null
  
)

export default component.exports